import { AxiosError, AxiosResponse } from 'axios';
import { action, observable } from 'mobx';
import { AuthService, BankFormResponse } from '../CommonInterfaces';
import config from '../Config';
import { BANK } from '../Routes';
import { API } from '../util/ApiUtil';
import ErrorUtil from '../util/ErrorUtil';
import GaDataStore from './GaDataStore';
import { mapAuthServiceToGaAuthType } from './LoginReturnStore';
import RememberMeStore from './RememberMeStore';
import RootStore from './RootStore';
import RouteStore from './RouteStore';

export default class BanksLoginStore {
  @observable accessor error: boolean = false;
  @observable accessor errorCode: string = '';
  @observable accessor mountBankForm: boolean = false;
  @observable accessor bankFormInitialized: boolean = false;
  @observable accessor formPostUrl: string | undefined;
  @observable accessor redirectData: Map<string, string> = new Map();

  public bankLoginInitialPath: string = '';

  private routeStore: RouteStore;
  private rememberMeStore: RememberMeStore;

  constructor(rootStore: RootStore) {
    this.routeStore = rootStore.routeStore;
    this.rememberMeStore = rootStore.rememberMeStore;
  }

  @action.bound
  public async handleBankClick(service: AuthService) {
    const { params, pathname } = this.routeStore;
    this.bankLoginInitialPath = pathname + params;
    const redirectUrl = BANK.replace(':authService', service) + this.routeStore.formForwardParamsForStartExternalAuth;
    if (window.top === window && !config.isModule) {
      this.routeStore.route(redirectUrl);
    } else if (config.isModule) {
      window.top!.location.href = `${config.frontendUrl}${redirectUrl}`;
    } else {
      window.top!.location.href = redirectUrl;
    }
  }

  public initializeBankFormData(authService: string) {
    const formForwardParams = this.routeStore.formForwardParams;
    const url = `/bank/auth/${authService}${formForwardParams ? formForwardParams : ''}`;
    return API.get(url)
      .then((response) => this.handleSuccess(response, authService))
      .catch((e: Error | string | any) => this.handleError(e, authService));
  }

  private handleError = (e: AxiosError, authService: string) => {
    ErrorUtil.pushErrorToTeliaRumAndLog(e);
    this.routeStore.route(this.bankLoginInitialPath);
    GaDataStore.loginStatus(false, mapAuthServiceToGaAuthType[authService], this.rememberMeStore.rememberMe);
  };

  @action.bound
  private handleSuccess(response: AxiosResponse, authService: string) {
    const loginResponse: BankFormResponse = response.data;
    this.formPostUrl = loginResponse.params.formPostUrl;
    this.redirectData = new Map(Object.entries(loginResponse.params.redirectData || {}));
    this.bankFormInitialized = true;
    GaDataStore.loginStatus(true, mapAuthServiceToGaAuthType[authService], this.rememberMeStore.rememberMe);
  }
}
